/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_BodyweightInputs */

const en_us2_workout_quick_bodyweight = /** @type {(inputs: Workout_Quick_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bodyweight`)
};

const pt_br2_workout_quick_bodyweight = /** @type {(inputs: Workout_Quick_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`peso corporal`)
};

const es_419_workout_quick_bodyweight = /** @type {(inputs: Workout_Quick_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`peso corporal`)
};

const pt_pt2_workout_quick_bodyweight = /** @type {(inputs: Workout_Quick_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`peso corporal`)
};

const fr_fr2_workout_quick_bodyweight = /** @type {(inputs: Workout_Quick_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`poids de corps`)
};

const de_de2_workout_quick_bodyweight = /** @type {(inputs: Workout_Quick_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körpergewicht`)
};

const it_it2_workout_quick_bodyweight = /** @type {(inputs: Workout_Quick_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`corpo libero`)
};

/**
* | output |
* | --- |
* | "bodyweight" |
*
* @param {Workout_Quick_BodyweightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_bodyweight = /** @type {((inputs?: Workout_Quick_BodyweightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_BodyweightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_bodyweight(inputs)
	if (locale === "es-419") return es_419_workout_quick_bodyweight(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_bodyweight(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_bodyweight(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_bodyweight(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_bodyweight(inputs)
	return en_us2_workout_quick_bodyweight(inputs)
});
export { workout_quick_bodyweight as "workout-quick.bodyweight" }